import { gql } from '@apollo/client';

export const GET_SMTP_CREDENTIALS = gql`
  query GetSmtpCredentials {
    me {
      id
      smtpCredential {
        id
        profileId
        host
        port
        username
        fromAddress
        fromName
      }
    }
  }
`;

export const CREATE_SMTP_CREDENTIAL = gql`
  mutation CreateSmtpCredential($input: SmtpCredentialInput!) {
    createSmtpCredential(input: $input) {
      id
      host
      port
      username
      fromAddress
      fromName
    }
  }
`;

export const UPDATE_SMTP_CREDENTIAL = gql`
  mutation UpdateSmtpCredential($id: ID!, $input: SmtpCredentialInput!) {
    updateSmtpCredential(id: $id, input: $input) {
      id
      host
      port
      username
      fromAddress
      fromName
    }
  }
`;

export const DELETE_SMTP_CREDENTIAL = gql`
  mutation DeleteSmtpCredential($id: ID!) {
    deleteSmtpCredential(id: $id)
  }
`;

export const TEST_SMTP_CONNECTION = gql`
  mutation TestSmtpConnection($input: SmtpCredentialInput!) {
    testSmtpConnection(input: $input)
  }
`;
